import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { message } from 'antd'
import type { BuildingsAccessListState } from '../types'
import { buildingsAccessFullList } from './helpers'

const noBuildingsAccessListConfig = {
  buildingsAccessList: [],
  isBcInitalized: false,
  isBcLoading: true,
  hasBcError: false,
}

interface BuildingsAccessListPayload {
  buildingsAccessList?: []
}

const initialState: BuildingsAccessListState = { ...noBuildingsAccessListConfig }

export const buildingsAccessListSlice = createSlice({
  name: 'BuildingsAccessList',
  initialState,
  reducers: {
    fetchBuildingsAccessList: (state) => {
      state.isBcLoading = true
      state.hasBcError = false
    },
    setBuildingsAccessList: (state, action: PayloadAction<BuildingsAccessListPayload>) => {
      state.buildingsAccessList = action.payload.buildingsAccessList
      state.isBcLoading = false
      state.isBcInitalized = true
      state.hasBcError = false
    },
    deleteBuildingsAccessList: (state, action: PayloadAction<BuildingsAccessListPayload>) => {
      state.buildingsAccessList = []
      state.isBcInitalized = false
      state.isBcLoading = false
      state.hasBcError = false
    },
    fetchBuildingsAccessListFailed: (state) => {
      state.buildingsAccessList = []
      state.isBcInitalized = false
      state.isBcLoading = false
      state.hasBcError = true
    },
  },
})

export const fetchAllBuildingsAccessList = () => async (dispatch) => {
  try {
    dispatch(fetchBuildingsAccessList())
    const buildingsAccessList = await buildingsAccessFullList()
    dispatch(
      setBuildingsAccessList({
        buildingsAccessList,
      }),
    )
  } catch (error) {
    message.error('Access list not fond')
    dispatch(fetchBuildingsAccessListFailed())
  }
}

// Actions
export const { fetchBuildingsAccessList, setBuildingsAccessList, fetchBuildingsAccessListFailed } =
  buildingsAccessListSlice.actions

export default buildingsAccessListSlice.reducer
